import React, { useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { ErroContainer, Form } from "../../styles/GlobalStyles";
import {
  InputContainer,
  InputContainerCourse,
  InputContainerYear,
  CourseDiv,
} from "./styled";
import api from "../../api/axios";
import { toast } from "react-toastify";

export const CreateNewAcademicModal = ({
  open,
  onClose,
  user,
  type,
  course,
}) => {
  const [values, setValues] = useState({
    type: "",
    course: "",
    duration: "",
    origin: "",
    year: "",
    deliveryMode: "",
    certificate: null, // certificado/diploma/etc.
  });

  const [error, setError] = useState("");

  const handleSubmit = async () => {
    setError("");
    const isFormValid = Object.values(values).every((v) => v !== "");

    if (!isFormValid) {
      setError("Por favor, preencha todos os campos!");
      return;
    }

    const formData = new FormData();
    formData.append("certificate", values.certificate);
    formData.append(
      "courseData",
      JSON.stringify({
        type: values.type,
        course: values.course,
        duration: values.duration,
        origin: values.origin,
        year: values.year,
        deliveryMode: values.deliveryMode,
      }),
    );

    try {
      await api.put(`/professional/update-courses/${user._id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      resetValues();
      onClose();
    } catch (error) {
      toast.error(error);
    }
  };

  const handleEditSave = async () => {
    setError("");
    const isFormValid = Object.values(values).every((v) => v !== "");

    if (!isFormValid) {
      setError("Por favor, preencha todos os campos!");
      return;
    }

    const index = user.courses.indexOf(course);

    if (values.certificate instanceof File) {
      const formData = new FormData();
      formData.append("certificate", values.certificate);
      formData.append("courseData", JSON.stringify({ ...values, index }));

      try {
        await api.put(`/professional/update-course/${user._id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        resetValues();
        onClose();
      } catch (error) {
        toast.error(error);
      }
    } else {
      const updatedCourses = [...user.courses];
      updatedCourses[index] = values;

      try {
        await api.put(`/professional/update/${user._id}`, {
          courses: updatedCourses,
        });
        resetValues();
        onClose();
      } catch (error) {
        toast.error(error);
      }
    }
  };

  const handleDelete = async () => {
    try {
      const index = user.courses.indexOf(course);

      await api.delete(`/professional/delete-course/${user._id}/${index}`);

      resetValues();
      onClose();
    } catch (err) {
      toast.error(err);
    }
  };

  const handleClose = () => {
    resetValues();
    setError("");
    onClose();
  };

  const resetValues = () => {
    setValues({
      type: "",
      course: "",
      duration: "",
      origin: "",
      year: "",
      deliveryMode: "",
    });
  };

  useEffect(() => {
    if (course) setValues(course);
  }, [course]);

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "900px",
          minWidth: "300px",
        },
      }}
    >
      <DialogTitle textAlign="center">{`${
        type === "create"
          ? "Adicionar nova"
          : type === "edit"
            ? "Editar"
            : "Deseja remover esta"
      } informação acadêmica${
        type === "delete" ? "? (Essa ação é irreversível)" : ""
      }`}</DialogTitle>
      <DialogContent>
        <Form>
          <Stack
            sx={{
              width: "100%",
              minWidth: "300px",
              gap: "1.5rem",
            }}
          >
            <InputContainer>
              <label for="type">
                Tipo:
                <span title="Campo obrigatório">*</span>
              </label>
              <Select
                id="type"
                name="type"
                value={values.type}
                onChange={(e) => {
                  setValues({ ...values, type: e.target.value });
                  setError("");
                }}
                disabled={type === "delete"}
              >
                <MenuItem value={"Curso"}>Curso</MenuItem>
                <MenuItem value={"Pós-Graduação"}>Pós-Graduação</MenuItem>
                <MenuItem value={"Mestrado"}>Mestrado</MenuItem>
                <MenuItem value={"Doutorado"}>Doutorado</MenuItem>
              </Select>
            </InputContainer>
            <InputContainer>
              <label for="origin">
                Instituição:
                <span title="Campo obrigatório">*</span>
              </label>
              <input
                id="origin"
                name="origin"
                type="text"
                value={values.origin}
                disabled={type === "delete"}
                onChange={(e) => {
                  setValues({ ...values, origin: e.target.value });
                  setError("");
                }}
              />
            </InputContainer>
            <CourseDiv>
              <InputContainerCourse>
                <label for="course">
                  Curso:
                  <span title="Campo obrigatório">*</span>
                </label>
                <input
                  id="course"
                  name="course"
                  type="text"
                  value={values.course}
                  disabled={type === "delete"}
                  onChange={(e) => {
                    setValues({
                      ...values,
                      course: e.target.value,
                    });
                    setError("");
                  }}
                />
              </InputContainerCourse>
              <InputContainerYear>
                <label for="year">
                  Ano:
                  <span title="Campo obrigatório">*</span>
                </label>
                <input
                  id="year"
                  name="year"
                  type="number"
                  value={values.year}
                  disabled={type === "delete"}
                  onChange={(e) => {
                    setValues({
                      ...values,
                      year: e.target.value,
                    });
                    setError("");
                  }}
                  onKeyDown={(e) => {
                    if (
                      [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ].includes(e.key)
                    ) {
                      return;
                    }

                    if (!/^\d$/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    if (!/^\d+$/.test(e.clipboardData.getData("text"))) {
                      e.preventDefault();
                    }
                  }}
                  maxLength={4}
                  minLength={4}
                />
              </InputContainerYear>
            </CourseDiv>
            <InputContainer>
              <label for="delivery-mode">
                Modalidade:
                <span title="Campo obrigatório">*</span>
              </label>
              <Select
                id="delivery-mode"
                name="delivery-mode"
                value={values.deliveryMode}
                disabled={type === "delete"}
                onChange={(e) => {
                  setValues({ ...values, deliveryMode: e.target.value });
                  setError("");
                }}
              >
                <MenuItem value={"Presencial"}>Presencial</MenuItem>
                <MenuItem value={"Híbrido"}>Híbrido</MenuItem>
                <MenuItem value={"Online"}>Online</MenuItem>
              </Select>
            </InputContainer>
            <InputContainer>
              <label for="duration">
                {"Carga horária (em horas):"}
                <span title="Campo obrigatório">*</span>
              </label>
              <input
                id="duration"
                name="duration"
                type="number"
                value={values.duration}
                disabled={type === "delete"}
                onChange={(e) => {
                  setValues({ ...values, duration: e.target.value });
                  setError("");
                }}
              />
            </InputContainer>
            <InputContainer>
              <label htmlFor="certificate">Anexar certificado:</label>
              <Button
                variant="outlined"
                component="label"
                disabled={type === "delete"}
                sx={{ textTransform: "none", fontWeight: 400 }}
              >
                Escolher arquivo
                <input
                  id="certificate"
                  name="certificate"
                  type="file"
                  hidden
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={(e) => {
                    setValues({ ...values, certificate: e.target.files[0] });
                  }}
                />
              </Button>
              {values.certificate && (
                <span style={{ fontSize: 13, marginTop: "5px" }}>
                  Arquivo selecionado:{" "}
                  {values.certificate.name || (
                    <a
                      href={values.certificate}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#104467",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      {values.certificate}
                    </a>
                  )}
                </span>
              )}
            </InputContainer>
          </Stack>
        </Form>
        <ErroContainer>{error ? error : ""}</ErroContainer>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button sx={{ color: "#104467" }} onClick={handleClose}>
          Cancelar
        </Button>
        <Button
          sx={{ backgroundColor: "#104467", color: "white" }}
          onClick={
            type === "create"
              ? handleSubmit
              : type === "edit"
                ? handleEditSave
                : handleDelete
          }
          variant="contained"
        >
          {type === "delete" ? "Confirmar" : "Salvar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
